<template>
  <a-modal
    @ok="handleSave"
    @cancle="handleCancle"
    v-model:visible="addModal"
    :title="title"
    centered
    width="450px"
  >
    <div>
      <div class="addModal">
        <span>航线名称</span>
        <a-input
          placeholder="请输入航线名称"
          v-model:value="waylineForm.name"
          class="mt5"
        ></a-input>
        <div class="form-tips" v-show="errorForm.nameNone">
          航线名称不能为空
        </div>
        <div class="form-tips" v-show="errorForm.nameOr">
          航线名称已存在，请修改后重试
        </div>
      </div>

      <div class="addModal">
        <span>关联机场</span><br />
        <a-select
          v-model:value="assAirport"
          placeholder="请选择关联机场"
          class="sel"
        >
          <a-select-option
            v-for="device in dockSnList"
            :key="device.device_sn"
            :value="device.device_sn"
            >{{ device.device_name }}</a-select-option
          >
        </a-select>
      </div>

      <div class="addModal">
        <span>航线属性</span><br />
        <a-select v-model:value="waylineForm.wayline_property" class="sel">
          <a-select-option
            v-for="item in waylineAttribute"
            :key="item.dict_value"
            :value="item.dict_value"
            >{{ item.dict_label }}</a-select-option
          >
        </a-select>
      </div>

      <div v-if="waylineForm.wayline_property === '1'" class="addModal">
        <span>适用人员</span>
        <a-button type="text" class="ml-63 c189" @click="createUserPanel"
          >添加人员</a-button
        >
        <a-input v-model:value="waylineForm.user_names"></a-input>
      </div>

      <div class="addModal">
        <span>选择飞机飞行器与负载</span><br />
        <a-select
          v-model:value="choseValue"
          class="chose"
          @change="handleDeviceChange"
        >
          <a-select-option
            v-for="item in DEVICE_SERVER_LIST"
            :key="item.value"
            :disabled="waylineForm.template_types.includes('3') && item.value === DRONE_TYPE.M30"
            :value="item.value"
          >
            {{ item.label }}</a-select-option
          >
        </a-select>
        <a-select
          v-model:value="videoValue"
          class="chose ml5"
          @change="handleDeviceCameraChange"
        >
          <a-select-option
            v-for="item in DEVICE_CAMERA_LIST[choseValue]"
            :disabled="waylineForm.template_types.includes('3') && choseValue === DRONE_TYPE.M30"
            :key="item.value"
            :value="item.value"
          >
            {{ item.label }}</a-select-option
          >
        </a-select>
      </div>

      <div v-if="cameraPayload.length > 0" class="addModal">
        <span>选择负载</span><br />
        <a-button
          v-for="item in cameraPayload"
          :key="item.id"
          :value="item.id"
          class="ml5"
          >{{ item.dict_label }}</a-button
        >
        <div v-if="title !== '新增航线'" class="form-tips">
          由于机型/负载之间的能力差异，航线文件中在转换后的机型/负载上无法执行的航点动作将会移除，可执行的航点动作将会保留且部分参数会被重置。可将航线复制备份后，再进行转换。
        </div>
      </div>

      <div class="addModal" v-if="!waylineForm.id">
        <span>航线类型</span><br />
        <div class="mt5">
          <a-button
            @click="handleChangeType(item)"
            v-for="item in waylineComType"
            :key="item.id"
            :value="item.id"
            :class="{
              'ant-btn-true': waylineForm.template_types.includes(
                item.dict_value,
              ),
            }"
            :disabled="item.dict_value === '3'"
            class="ml5"
          >
            <template #icon>
              <i class="iconfont icon-waypoint" :data-id="item.dict_value" v-show="item.dict_value === '0'"></i>
              <i class="iconfont icon-mapping2d" :data-id="item.dict_value" v-show="item.dict_value === '1'"></i>
              <i class="iconfont icon-mappingStrip" :data-id="item.dict_value" v-show="item.dict_value === '3'"></i>
            </template>
            {{ item.dict_label }}
          </a-button>
        </div>
      </div>
    </div>

    <!-- 外部并排的添加人员面板 -->
    <div v-if="showUserPanel" :style="userPanelStyle">
      <div class="user-top">
        <div class="user-text">添加人员</div>
        <div class="user-close">
          <close-outlined @click="handleCloseUserPanel"></close-outlined>
        </div>
      </div>

      <a-checkbox-group
        v-model:value="selectedUserIds"
        style="width: 100%"
        @change="handleUserPanelChange"
      >
        <a-row>
          <a-col :span="24" v-for="user in userList" :key="user.user_id">
            <a-checkbox :value="user.user_id">{{ user.username }}</a-checkbox>
          </a-col>
        </a-row>
      </a-checkbox-group>
    </div>
    <a-modal
      :footer="false"
      :closable="false"
      v-model:visible="updateTipModal"
      width="420px"
      centered
      wrapClassName="route-update-modal del-modal"
    >
      <div class="route-modal-title">更新</div>
      <div class="route-modal-form-data">
        <div class="form-key">
          更换飞行器或负载型号将影响航线作业参数，请谨慎操作!
        </div>
      </div>

      <div class="route-modal-footer">
        <a-button @click="handleCloseUpdate">取消</a-button>
        <a-button type="danger" @click="handleChangeUpdate">确认</a-button>
      </div>
    </a-modal>
  </a-modal>
</template>
<script setup lang="ts">
import {
  ref,
  defineEmits,
  withDefaults,
  defineExpose,
  defineProps,
  onMounted,
  computed,
} from 'vue'
import { lineSaveForm } from '/@/api/wayline'
import {
  Device,
  DEVICE_CAMERA_LIST,
  DEVICE_SERVER_LIST,
  deviceSerie,
  DRONE_TYPE,
} from '/@/types/device'
import { getDictDataList, getParentParam } from '/@/api/dict'
import { ELocalStorageKey } from '/@/types'
import { getAllUsersInfo, getDevice } from '/@/api/manage'
import { IPage } from '/@/api/http/type'

// 计算面板定位样式
const userPanelStyle = computed(() => ({
  position: 'fixed',
  top: '31.7%',
  left: 'calc(50% + 225px + 4px)', // 450px/2+24px间距
  transform: 'translateY(-50%)',
  width: '320px',
  background: '#fff',
  padding: '8px 12px',
  boxShadow: '-2px 0 4px rgba(0,0,0,0.06)',
  zIndex: 2000,
  borderRadius: '4px',
  minHeight: '300px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  justifyContent: 'flex-start',
}))

const props = withDefaults(
  defineProps<{
    title?: string;
  }>(),
  {
    title: '新建航线',
  },
)
interface SavePayload {
  form: lineSaveForm;
  assAirport: string;
  choseValue: number;
  videoValue: number;
  errorForm: {
    nameNone: boolean;
    nameOr: boolean;
  };
}
const emits = defineEmits<{
  save: [SavePayload];
}>()

const addModal = ref(false)
const workspaceId = localStorage.getItem(ELocalStorageKey.WorkspaceId)!
const waylineForm = ref<lineSaveForm>({
  name: '',
  drone_model_key: '',
  payload_model_keys: [],
  template_types: [],
  wayline_property: '',
  user_names: '',
  user_id_list: [],
})
const errorForm = ref({
  nameNone: false,
  nameOr: false,
})
const assAirport = ref(null)
const dockSnList = ref<Device[]>([])
const cameraPayload = ref<any[]>([])
const waylineComType = ref<any[]>([])
const attributes = ref('')
const updateTipModal = ref(false)
const updateType = ref('')
const updateId = ref(null)
const choseValue = ref(DRONE_TYPE.M30)

const videoValue = ref(DEVICE_CAMERA_LIST[choseValue.value][0].value)

const waylineAttribute = ref<any[]>([])
const showUserPanel = ref(false)
const userList = ref<any[]>([])
const selectedUserIds = ref<string[]>([])
const body: IPage = {
  page: 1,
  total: 0,
  page_size: 100,
}
function createUserPanel () {
  if (showUserPanel.value) {
    handleCloseUserPanel()
    return
  }
  showUserPanel.value = true
  if (userList.value && userList.value.length > 0) {
    return
  }
  getAllUsersInfo(workspaceId, body).then((res) => {
    if (res && res.code === 0) {
      userList.value = res.data.list
    }
  })
}
function handleCloseUserPanel () {
  showUserPanel.value = false
}
function handleUserPanelChange (val: string[]) {
  const names = userList.value.filter((u) => val.includes(u.user_id))
  waylineForm.value.user_names = names.map((u) => u.username).join(', ')
  waylineForm.value.user_id_list = names.map((u) => u.user_id)
}
async function deviceSerieDataList () {
  const res = await getParentParam('device_series', 0) // 这里'dict_code'需替换为实际后端字典code
  if (res && res.code === 0) {
    // deviceSerie = res.data || []

    if (deviceSerie.length > 0) {
      waylineForm.value.payload_model_keys = deviceSerie[0].dict_value
      await Promise.all([
        deviceDataList(deviceSerie[0].id),
        payloadRemark(deviceSerie[0].id),
      ])
      if (cameraSerie.value.length > 0) {
        waylineForm.value.drone_model_key = cameraSerie.value[0].dict_label
      }
    }
  }
}

async function payloadRemark (parentId) {
  cameraPayload.value = []
  if (!parentId) return

  const res = await getParentParam('device_series', parentId)
  if (res && res.code === 0) {
    cameraPayload.value = (res.data || []).filter((item) => {
      return item.remark && item.remark.trim() !== ''
    })
  }
}
const cameraSerie = computed(() => {
  return deviceSerie.find((e) => e.value === choseValue.value).children
})
async function deviceDataList (parentId) {
  videoValue.value = null
  cameraSerie.value = []

  if (!parentId) return

  const res = await getParentParam('device_series', parentId) // 这里'dict_code'需替换为实际后端字典code
  if (res && res.code === 0) {
    cameraSerie.value = (res.data || []).filter((item) => {
      return !item.remark || item.remark.trim() === ''
    })

    if (cameraSerie.value.length > 0) {
      videoValue.value = cameraSerie.value[0].dict_label
    }
  }
}
async function waylineAttList () {
  const res = await getDictDataList('route_attribute')
  if (res && res.code === 0) {
    waylineAttribute.value = res.data || []

    if (waylineAttribute.value.length > 0) {
      waylineForm.value.wayline_property = waylineAttribute.value[0].dict_value
    }
  }
}
async function getDockSN () {
  try {
    const param = {
      workspace_id: workspaceId,
      domains: [3],
    }
    const res = await getDevice(param)
    if (res && res.code === 0) {
      dockSnList.value = res.data
    }
  } catch (e) {
    console.log('获取设备列表时发生异常:', e)
  }
}
const oldDeviceValue = ref(null)
const oldDeviceCameraValue = ref(null)
function handleDeviceChange (selectedId) {
  if (waylineForm.value.id) {
    updateType.value = 'device'
    updateTipModal.value = true
    updateId.value = selectedId
    return
  }
  const row = DEVICE_SERVER_LIST.find((el) => el.value === selectedId)
  videoValue.value = DEVICE_CAMERA_LIST[selectedId][0].value
  // Promise.all([
  //   deviceDataList(selectedId),
  //   payloadRemark(selectedId)
  // ])
}
function handleChangeUpdate () {
  if (updateType.value === 'device') {
    oldDeviceCameraValue.value = updateId.value
    const row = DEVICE_SERVER_LIST.find((el) => el.value === updateId.value)
    videoValue.value = DEVICE_CAMERA_LIST[updateId.value][0].value
    oldDeviceValue.value = updateId.value
  } else if (updateType.value === 'camera') {
    videoValue.value = updateId.value
    oldDeviceCameraValue.value = updateId.value
  }
  updateTipModal.value = false
}
function handleCloseUpdate () {
  if (updateType.value === 'device') {
    choseValue.value = oldDeviceValue.value
  } else if (updateType.value === 'camera') {
    videoValue.value = oldDeviceCameraValue.value
  }
  updateTipModal.value = false
}
function handleDeviceCameraChange (selectId) {
  if (waylineForm.value.id) {
    updateType.value = 'camera'
    updateTipModal.value = true
    updateId.value = selectId
  }
}
const openModal = (row?: lineSaveForm) => {
  addModal.value = true
  waylineForm.value = {
    name: '',
    drone_model_key: '',
    payload_model_keys: [],
    template_types: [],
    wayline_property: '',
  }
  if (waylineAttribute.value && waylineAttribute.value[0].dict_value) {
    waylineForm.value.wayline_property = waylineAttribute.value[0].dict_value
  }
  if (waylineComType.value && waylineComType.value[0].dict_value) {
    waylineForm.value.template_types = [waylineComType.value[0].dict_value]
  }
  choseValue.value = DRONE_TYPE.M30
  videoValue.value = DEVICE_CAMERA_LIST[choseValue.value][0].value
  if (row && row.drone_type) {
    waylineForm.value = { ...row }
    waylineForm.value.template_types = [row.template_types[0] + '']
    waylineForm.value.wayline_property = row.wayline_property
      ? row.wayline_property + ''
      : waylineAttribute.value[0].dict_value
    if (row.device_sn) {
      assAirport.value = row.device_sn
    }
    choseValue.value = Number(row.drone_type)
    videoValue.value = Number(row.payload_types)
    oldDeviceValue.value = choseValue.value
    oldDeviceCameraValue.value = videoValue.value
  }
}
async function routeType () {
  const res = await getDictDataList('route_type')
  if (res && res.code === 0) {
    waylineComType.value = res.data || []
    waylineForm.value.template_types = [res.data[0].dict_value]
  }
}
function handleChangeType (item:{dict_value:string}) {
  waylineForm.value.template_types = [item.dict_value]
  if (item.dict_value === '3') {
    const lists = DEVICE_SERVER_LIST.filter(el => el.value !== DRONE_TYPE.M30)
    choseValue.value = lists[0].value
    videoValue.value = DEVICE_CAMERA_LIST[choseValue.value][0].value
  }
}
function handleSave () {
  if (!waylineForm.value.name) {
    errorForm.value.nameNone = true
    return
  }
  errorForm.value.nameNone = false
  errorForm.value.nameOr = false
  emits('save', {
    form: waylineForm.value,
    assAirport: assAirport.value,
    choseValue: choseValue.value,
    videoValue: videoValue.value,
    errorForm: errorForm.value,
  })
}

function handleCancle () {
  waylineForm.value = {
    name: '',
    drone_model_key: '',
    payload_model_keys: [],
    template_types: [],
    wayline_property: '',
  }
  errorForm.value = {
    nameNone: false,
    nameOr: false,
  }

  choseValue.value = DRONE_TYPE.M30
  videoValue.value = DEVICE_CAMERA_LIST[choseValue.value][0].value

  addModal.value = false
}

onMounted(() => {
  waylineAttList()
  getDockSN()
  routeType()
})
defineExpose({
  openModal,
  handleCancle,
})
</script>
<style scoped lang="scss">
.form-tips {
  color: red;
  font-size: 12px;
}
.ant-btn-true {
  color: #40a9ff;
  border-color: #40a9ff;
}
.addModal {
  margin-bottom: 20px;
  font-size: 15px;
}
.sel {
  margin-top: 5px;
  width: 100%;
}
.chose {
  width: 195px;
}
.user-top {
  position: relative;
  text-align: center;
  .user-text {
    font-size: 16px;
    font-weight: bold;
  }
  .user-close {
    position: absolute;
    right: 5px;
    top: 3px;
  }
}
</style>
